import { useEffect, useRef, useState } from 'react';
import DashboardSidebar from './Sections/DashboardSidebar';
import DashboardTopbar from './Sections/DashboardTopbar.jsx';
// import SetupPage from './DashboardPages/Setup';
import { useSearchParams } from 'react-router-dom';
// import Setup from './Setup/Setup'
import { useNavigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import allTabs, { tabs, sales_channels, bottom_tabs } from './DashboardTabs';
import DashboardSubTabs from '../components/ui/DashboardSubTabs';
import { useDispatch } from 'react-redux';
import systemSlice from '../redux/systemSlice';
import useCustomNavigate from '../components/operational/goBack';
import PrimaryButton from '../components/ui/PrimaryButton';
import SecondaryButton from '../components/ui/SecondaryButton';

const LayeredDashboardHeader = ({ tab, children, setIsActive, onSave, onLeave, onDelete }) => {

    const goBack = useCustomNavigate(tab)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    return (
        <>
            <div className="w-[100%] min-h-[60px] h-[60px]">
                <div className=" px-[25px] bg-white h-full border-b-[0px] text-lg self-center flex items-center w-full justify-between">
                    <div className='flex gap-[20px] items-center w-full'>
                        <div className=' overflow-hidden shrink-0'>

                            <div className='flex items-center gap-[15px]'>
                                <div className='border-[1.5px] rounded-md cursor-pointer broder-[#F8F8F8] p-3' onClick={() => {
                                    onLeave ? onLeave() : goBack()
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
                                        <path d="M6.60156 1L1.00156 6.6L6.60156 12.2" stroke="#8A92A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M0.999999 6.6001L15 6.6001" stroke="#8A92A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                {tab?.activeTabs?.map((tabId, index) => {
                                    const tabData = allTabs.find((tab, index) => tab.id === tabId)
                                    return (
                                        <>
                                            {
                                                index !== 0 &&
                                                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 11L5.13385 6.88384C5.62205 6.39773 5.62205 5.60227 5.13385 5.11616L1 1" stroke="#5E5873" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }
                                            <span className={`flex items-center  text-[16px]  font-medium text-[#8a92a6] hover:text-[#5E5873] cursor-pointer`}
                                                onClick={() => {
                                                    dispatch(systemSlice.actions.handleActiveSubTabs({ tabId, isClose: true }));
                                                    setIsActive?.(false)
                                                    setTimeout(() => {
                                                        navigate(tabData?.pointTo)
                                                    }, 350)
                                                }}
                                            >
                                                {tabData?.title || tab?.activeTabTitles?.[index]}
                                            </span>
                                        </>)
                                })}


                            </div>

                        </div>


                        <div className="flex flex-row items-center gap-4 md:gap-[20px] justify-end shrink-0 ml-auto">

                            <div className='flex gap-2 items-center'>
                                {children}
                                {onSave &&
                                    <>
                                        <button className={`text-[15px] py-[11px] px-4 flex items-center border-1 border-[#E3E8EF] justify-center bg-white  rounded text-[#8A92A6] cursor-pointer `}
                                            onClick={() => {
                                                onLeave ? onLeave() : goBack()
                                            }}
                                        >Vazgeç</button>
                                        {onDelete &&
                                            <SecondaryButton classes={"bg-red-600 text-white text-[16px] !py-3"} value={"Sil"} onClick={onDelete} />
                                        }
                                        <PrimaryButton classes="text-[16px] !py-3 " onClick={onSave} value={"Kaydet"} />
                                    </>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div >


        </>

    );
};

export default LayeredDashboardHeader;
